module.exports = __webpack_public_path__ + "static/img/delitang_icon.5e710fa.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shop_img_icon/delitang_icon.png
// module id = 9YH2
// module chunks = 1